import React from 'react';
import { Container, Row } from 'react-bootstrap';
import WhyChooseUsDetails from '../../../atoms/Card/WhyChooseUsDetails';
const WhyChoosUs =()=>{
    return(
        <>
          <section className='choose-section section-padding'>
            <Container >
                
                <Row>
                    <WhyChooseUsDetails />
                </Row>
            </Container>
          </section>
        </>
    )
}
export default WhyChoosUs